// src/ExchangeToggleButton.tsx
import React, { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { jsx } from "react/jsx-runtime";
var ExchangeToggleButton = React.forwardRef(({
  expanded,
  onClick,
  floating = false,
  hiddenFromAccessibility = false
}, ref) => {
  const [isFocused, setIsFocused] = useState(false);
  const isHidden = hiddenFromAccessibility && !isFocused;
  return /* @__PURE__ */ jsx(
    "button",
    {
      ref,
      type: "button",
      onClick,
      onFocus: () => setIsFocused(true),
      onBlur: () => setIsFocused(false),
      className: "pointer-events-auto inline-flex h-11 w-11 items-center justify-center",
      "aria-label": expanded ? "Collapse prompt and answer" : "Expand prompt and answer",
      "aria-expanded": expanded,
      "aria-hidden": isHidden,
      tabIndex: isHidden ? -1 : 0,
      title: expanded ? "Collapse prompt and answer" : "Expand prompt and answer",
      children: /* @__PURE__ */ jsx(
        "span",
        {
          className: `inline-flex h-4 w-4 items-center justify-center rounded-[4px] border border-edge-gray-300 bg-fill-white transition-colors hover:border-edge-gray-400 hover:bg-fill-gray-100 dark:border-edge-gray-600 dark:bg-fill-dialog-surface dark:hover:bg-fill-gray-700 ${floating ? "shadow-sm" : ""}`,
          style: { color: "var(--photon-chat-accent)" },
          children: expanded ? /* @__PURE__ */ jsx(Minus, { size: 10 }) : /* @__PURE__ */ jsx(Plus, { size: 10 })
        }
      )
    }
  );
});
ExchangeToggleButton.displayName = "ExchangeToggleButton";
var ExchangeToggleButton_default = ExchangeToggleButton;
export {
  ExchangeToggleButton_default as default
};
